module.exports = __webpack_public_path__ + "img/img_nav_vip_hover.1eba6e13.svg";